import React, { memo } from "react";
import SportsbookWrapper from "../sportsbookWrapper";

const Prematch = () => <SportsbookWrapper gameType="prematch" />;

export default memo(Prematch);
